import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 872F02FE-ABEF-4187-B6B2-87A548988EAA
 * name shield-plus
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-plus.svg
 * tags
 */
export const ShieldPlusIcon = createSvgIcon(<><path d="M19,20V22.97H17V20H14V18H17V15H19V18H22V20H19M12,1L21,5V11C21,11.9 20.9,12.78 20.71,13.65C19.9,13.23 19,13 18,13A6,6 0 0,0 12,19C12,20.36 12.45,21.62 13.22,22.62L12,23C6.84,21.74 3,16.55 3,11V5L12,1Z" /></>, 'ShieldPlusIcon');
export default ShieldPlusIcon